import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import Coachmark from 'components/common/coachmark'
import { COACHMARK_POSITION } from 'components/common/coachmark/const'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'

const ReviewsRatingsCoachMark = ({ coachmarkText }) => {
  const coachmarkRef = useRef(null)
  const [isOpenCoachmark, setIsOpenCoachmark] = useState(false)

  return (
    <div>
      <Icon
        alt="reviews ratings info button"
        src={ICONS.info}
        size={ICON_SIZE.small}
        onClick={() => setIsOpenCoachmark(true)}
      />
      <Coachmark
        onClose={() => setIsOpenCoachmark(false)}
        position={COACHMARK_POSITION.TOP_LEFT}
        text={coachmarkText}
        isOpen={isOpenCoachmark}
        customContainerProps={{
          style: {
            right: '-176px',
            top: '12px',
            width: '1200%',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            textAlign: 'left',
          },
        }}
        disableLeaveListener
        disableEnterListener
        customChildrenRef={coachmarkRef}
      />
    </div>
  )
}

ReviewsRatingsCoachMark.propTypes = {
  // component props
  coachmarkText: PropTypes.string.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(ReviewsRatingsCoachMark)
